import { Button, Modal, Form, Input, InputNumber } from "antd";
import { SwapOutlined, SaveOutlined, CloseCircleOutlined } from "@ant-design/icons";
import { useState } from "react";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import { useDispatch, useSelector } from "react-redux";
import { startSolicitarReembolso } from "../../../../context/actions/reembolsoActions";

export const BotonReembolsos = () => {
    const [open, setOpen] = useState(false);
    const [loading, setLoading] = useState(false);
    const [form] = Form.useForm();
    const { asistenciaID } = useParams()

    const reembolso = useSelector((state) => state.detalleReducer.asistencia.reembolso)
    const dispatch = useDispatch()

    const handleSubmit = async () => {
        try {
            const values = await form.validateFields()
            setLoading(true)
            const ok = await dispatch(startSolicitarReembolso({
                asistenciaID,
                descripcion: values.descripcion,
                monto: values.monto,
                nombreUsuarioFinalSolicita: values.nombreUsuario,
                telefonoUsuarioFinalSolicita: values.telefono,
                motivoReembolso: values.motivoReembolso,
            }))
            if (ok) {
                form.resetFields()
                setOpen(false)
            }
        } catch (e) {
            console.error("Error al solicitar reembolso", e)
        } finally {
            setLoading(false)
        }
    }

    if (reembolso) {
        return (
            <div style={{ fontSize: 14, lineHeight: "22px" }}>
                <span className="inputLabel">Reembolso:</span> Creado
            </div>
        )
    }

    return (
        <>
            <Button
                onClick={() => setOpen(true)}
                type="dashed"
                icon={<SwapOutlined />}
            >
                Reembolsos
            </Button>
            <Modal
                title={<span><SwapOutlined style={{ marginRight: 8 }} />Crear Reembolso</span>}
                open={open}
                onCancel={() => { form.resetFields(); setOpen(false); }}
                onOk={handleSubmit}
                confirmLoading={loading}
                okText={<span><SaveOutlined style={{ marginRight: 6 }} />Crear</span>}
                cancelText={<span><CloseCircleOutlined style={{ marginRight: 6 }} />Cancelar</span>}
                cancelButtonProps={{ danger: true, type: "primary", style: { borderRadius: 6 } }}
                okButtonProps={{ style: { borderRadius: 6 } }}
            >
                <Form form={form} layout="vertical">
                    <Form.Item name="monto" label="Monto" rules={[{ required: true, message: "" }]}>
                        <InputNumber min={0.01} step={0.01} style={{ width: "100%", borderRadius: 6 }} />
                    </Form.Item>
                    <Form.Item name="descripcion" label="Descripción" rules={[{ required: true, message: "" }]}>
                        <Input.TextArea rows={2} style={{ borderRadius: 6 }} />
                    </Form.Item>
                    <Form.Item name="motivoReembolso" label="Motivo" rules={[{ required: true, message: "" }]}>
                        <Input style={{ borderRadius: 6 }} />
                    </Form.Item>
                    <Form.Item name="nombreUsuario" label="Nombre usuario final" rules={[{ required: true, message: "" }]}>
                        <Input style={{ borderRadius: 6 }} />
                    </Form.Item>
                    <Form.Item name="telefono" label="Teléfono usuario final" rules={[{ required: true, message: "" }]}>
                        <Input style={{ borderRadius: 6 }} />
                    </Form.Item>
                </Form>
            </Modal>
        </>
    );
};
